// src/components/EntertainmentEventsBanner.js
import React from 'react';
import './EntertainmentEventsBanner.css'; // Reusing the same styles

const EntertainmentEventsBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">VENUE MANAGEMENT</h2>
      </div>
    </div>
  );
};

export default EntertainmentEventsBanner;
